import { useEffect } from 'react'
import { useFilterDimsState } from '~/state/useFilterDimsState'
import type { ContributionView } from '~/state/useContributionView'

/**
 * The Contribution GROUPS view shows sales__total__units grouped by Driven by Group. That kpi carries both
 * Model=yhat (Fitted; has lever dims) and Model=actual (gauge-only, no Driven by Group), so the view only
 * renders if the actual rows are excluded. This structurally enforces Model=Fitted on the groups view whenever
 * no Model filter is set — re-asserting after Reset Settings (unlike a mount-once default). Scoped to groups:
 * the channels view (sales__media__units) is Fitted-only and needs no Model filter. Selecting Model=Actual
 * explicitly is NOT overridden (the filter is then present); grouping Actual by a lever dim then shows the
 * SP-1 "not applicable" note, which is the correct per-side behavior.
 */
export function useContributionModelDefault(view: ContributionView): void {
  const [filters, setFilters] = useFilterDimsState()
  useEffect(() => {
    if (view === 'groups' && !filters.Model?.length) {
      setFilters({ ...filters, Model: ['yhat'] }, { replace: true })
    }
  }, [view, filters, setFilters])
}
